import { FieldActivity } from './FieldActivity';

export class UserFieldActivity {
  RecordId?: number;
  Id?: number;
  UserId: number;
  FieldActivityId: number;
  FieldActivity: FieldActivity;
  CreatedBy: number;
  CreatedDate: string;
  ModifiedBy: number;
  ModifiedDate: string;
  IsActive: boolean;
  IsArchived: boolean;
  IsDeleted: boolean;

  constructor(obj?: Partial<UserFieldActivity>) {
    if (obj) {
      Object.assign(this, obj);
    } else {
      throw Error('Object cannot be null');
    }
  }

  isSoftDeleted(): boolean {
    return this.IsDeleted;
  }
}
